import { Badge } from "@/components/ui";
import { COLOR_POR_CATEGORIA } from "../data/acciones-tono";

export function CategoriaBadge({ categoria }: { categoria: string }) {
  return (
    <Badge variant="light" color={COLOR_POR_CATEGORIA[categoria] ?? "slate"}>
      {categoria}
    </Badge>
  );
}
